import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sp-menu-v2',
  standalone: false,
  templateUrl: './menu-v2.component.html',
  styleUrls: ['./menu-v2.component.scss']

})
export class MenuV2Component implements OnInit, OnChanges {
  @Input() groups: Array<Link> = [];
  @Input() style: string = 'dark';
  @Input() direction: string = 'vertical';
  parentsArray: Array<Link> = [];
  currentUrl: string;
  @Output() linkClicked = new EventEmitter<any>();

  constructor(private router: Router) { }

  ngOnInit() {
    this.currentUrl = this.router.url;
  }

  ngOnChanges() {
    if (this.groups) {
      this.assigningParentsToGroups(this.groups);
      this.urlFinder(this.groups, null);
    }
  }

  shrinkGroup(group) {
    group['isOpen'] = false;
  }

  loadSubGroups(group) {
    group['isOpen'] = true;
    if (group.links) {
      return group.links;
    }
  }

  urlFinder(groups, parent) {
    groups.forEach((group) => {
      if (group.link === this.currentUrl) {
        // group.isActive = true;
        if (parent) {
          parent.isOpen = true;
        }
        this.getParent(this.parentsArray, parent);
        return;
      } else {
        if (group.links) {
          this.parentsArray.push(group);
          this.urlFinder(group.links, group);
        }
      }
    });
  }

  assigningParentsToGroups(groups) {
    if (groups) {
      groups.forEach((group) => {
        if (group.links) {
          const { links } = group;
          links.forEach((subGroup) => {
            subGroup.hasParent = group.title;
          });
          this.assigningParentsToGroups(links);
        }
      });
    }
  }

  getParent(groups, pg) {
    if (pg?.hasParent) {
      const parent = groups.find((el) => el.title === pg.hasParent);
      if (parent) {
        parent.isOpen = true;
      }
      this.getParent(groups, parent);
    }
  }

  handleLinkNavigator(link = null, action = null) {
    const isExternalLink = link ? link.indexOf('http') >= 0 || link.indexOf('://') > 0 : null;
    if (isExternalLink) {
      window.open(link);
      return;
    }
    if (action) {
      action();
    }
  }
  hideMenu(e) {
    this.linkClicked.emit(e);
  }
}

export interface MenuV2ObjectInterface {
  links: Array<Link>;
  style?: string;
  direction?: string;
}

export interface Link {
  title: string;
  isOpen: boolean;
  link?: string; // /home/request/list  # http://xxxxx.com
  externalLink?: string;
  icon?: string;
  count?: number;
  queryParams?: Record<string, unknown>;
  links?: Array<Link>;
  action?: any;
  customClass?: string;
  subTitle?: boolean;
  isRTL: boolean;
}